module.exports = __webpack_public_path__ + "img/information.4db9e95e.png";